import Certification from './certification';
import Scommunication from './sco-communication';
import Survey from './survey';

<template>
  <div class="top-banners">
    <Certification />
    <Scommunication />
    <Survey />
  </div>
</template>
